/**
 * Errors we should NOT forward to Telegram / redundant client-error BE
 * pings, and optionally drop from Sentry beforeSend.
 *
 * Common case: Chrome extensions (AdBlock, privacy tools) wrap fetch() and
 * throw TypeError('Failed to fetch') before the browser issues a normal
 * network request — stacks show chrome-extension://…/frame_ant.js at the top.
 */

const EXTENSION_URL_MARKERS = [
  'chrome-extension://',
  'moz-extension://',
  'safari-extension://',
  'safari-web-extension://',
  'webkit-masked-url://',
] as const;

/** AdBlock anti-circumvention / fetch wrapper bundles */
const KNOWN_HOOK_MARKERS = ['frame_ant.js'];

/** React NotFoundError when a browser extension (Translate, Grammarly,
 *  password managers) wraps/moves text nodes and React later tries to
 *  removeChild a node that is no longer a direct child. Not actionable. */
const DOM_RECONCILE_NOISE = [
  "Failed to execute 'removeChild' on 'Node'",
  "Failed to execute 'insertBefore' on 'Node'",
  'The node to be removed is not a child of this node',
  'The node before which the new node is to be inserted is not a child of this node',
] as const;

/** Android In-App Browser (LINE / FB / IG WebView) IAB bridge — the
 *  native Java object is GC'd while JS still postMessages. Stacks show
 *  iabjs://…; not our app code. */
const ANDROID_IAB_NOISE = [
  'Java object is gone',
  'Error invoking postMessage',
  'iabjs://',
  'iab_inner_frame',
] as const;

export function suppressClientMonitoringEvent(message: string, stack?: string): boolean {
  const msg = message || '';
  const st = stack || '';

  for (const m of EXTENSION_URL_MARKERS) {
    if (st.includes(m)) return true;
  }
  if (EXTENSION_URL_MARKERS.some((m) => msg.includes(m))) return true;

  for (const m of KNOWN_HOOK_MARKERS) {
    if (st.includes(m)) return true;
  }

  if (DOM_RECONCILE_NOISE.some((m) => msg.includes(m))) return true;

  if (
    ANDROID_IAB_NOISE.some((m) => msg.includes(m) || st.includes(m))
  ) {
    return true;
  }

  return false;
}
